import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.review');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-review',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.review/view.scss */
/* src/app/page.review/view.scss: no such file or directory */`],
})
export class PageReviewComponent implements OnInit {
    public loading: boolean = true;
    public actionLoading: boolean = false;
    public detailLoading: boolean = false;
    public error: string = '';
    public summary: any = {};
    public queue: any[] = [];
    public stats: any[] = [];
    public availableCount: number = 0;
    public selectedReviewId: string = '';
    public detail: any = null;
    public decisionForm: any = {
        comment: '',
        reason_code: 'grounded_ok',
        change_summary: ''
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load();
    }

    public role() {
        return String(this.service.auth.session?.role || '').toLowerCase();
    }

    public isManagerRole() {
        return this.role() === 'manager';
    }

    public isReviewerRole() {
        return this.role() === 'reviewer';
    }

    public pageTitle() {
        return this.isManagerRole() ? '검수 결과' : 'QA 후보 검수';
    }

    public pageCaption() {
        return this.isManagerRole()
            ? '검수 진행 상태와 판정 결과를 확인합니다.'
            : '배정된 질문·답변과 근거만 확인합니다.';
    }

    public queueTitle() {
        return this.isManagerRole() ? '검수 항목' : '내 검수 항목';
    }

    public queueCaption() {
        return this.isManagerRole()
            ? `${this.number(this.queue.length)}건 조회`
            : `${this.number(this.queue.length)}건 배정`;
    }

    public emptyTitle() {
        return this.isManagerRole() ? '검수 결과가 없습니다.' : '배정된 QA 후보가 없습니다.';
    }

    public emptyCaption() {
        return this.isManagerRole()
            ? '검수 요청 또는 배정이 생성되면 이곳에 표시됩니다.'
            : '새로고침 후에도 없으면 관리자에게 배정을 요청하세요.';
    }

    public async load() {
        this.loading = true;
        this.error = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call("workbench", { limit: 120 });
            if (code === 200) {
                this.summary = data.summary || {};
                this.queue = data.queue || [];
                this.availableCount = Number(this.summary.available || 0);
                this.stats = this.buildStats(this.queue, this.summary);
                this.ensureSelectedReview();
                if (this.selectedReviewId) {
                    await this.loadDetail(this.selectedReviewId, false);
                } else {
                    this.detail = null;
                }
            } else {
                this.error = data?.message || '검수 대상을 불러오지 못했습니다.';
                this.queue = [];
                this.availableCount = 0;
                this.stats = this.buildStats([], {});
                this.detail = null;
            }
        } catch (error: any) {
            this.error = error?.message || '검수 대상을 불러오지 못했습니다.';
            this.queue = [];
            this.availableCount = 0;
            this.stats = this.buildStats([], {});
            this.detail = null;
        }

        this.loading = false;
        await this.service.render();
    }

    private ensureSelectedReview() {
        if (this.selectedReviewId && this.queue.some((item: any) => item.id === this.selectedReviewId)) return;
        const active = this.queue.find((item: any) => item.status === 'inspecting') || this.queue[0];
        this.selectedReviewId = active?.id || '';
    }

    private buildStats(items: any[], summary: any) {
        const assigned = items.filter(item => item.status === 'assigned').length;
        const inspecting = items.filter(item => item.status === 'inspecting').length;
        const completed = items.filter(item => item.status === 'completed').length;
        const pending = Number(summary.pending || 0);
        if (this.isManagerRole()) {
            return [
                { label: '검수 항목', value: items.length, tone: 'blue' },
                { label: '완료', value: completed, tone: 'green' },
                { label: '진행 중', value: inspecting, tone: 'indigo' },
                { label: '대기', value: pending, tone: 'amber' }
            ];
        }
        return [
            { label: '검수 대상', value: items.length, tone: 'blue' },
            { label: '진행 중', value: inspecting, tone: 'indigo' },
            { label: '배정됨', value: assigned, tone: 'green' },
            { label: '남은 후보', value: this.availableCount || pending, tone: 'amber' }
        ];
    }

    public async selectReview(review: any) {
        const reviewId = review?.id || '';
        if (!reviewId || reviewId === this.selectedReviewId) return;
        this.selectedReviewId = reviewId;
        await this.loadDetail(reviewId);
    }

    public async loadDetail(reviewId: string, render: boolean = true) {
        if (!reviewId) return;
        this.detailLoading = true;
        this.error = '';
        if (render) await this.service.render();

        try {
            const { code, data } = await wiz.call("detail", { review_id: reviewId });
            if (code === 200) {
                this.detail = data.detail || null;
                this.resetDecisionForm();
            } else {
                this.detail = null;
                this.error = data?.message || '검수 상세를 불러오지 못했습니다.';
            }
        } catch (error: any) {
            this.detail = null;
            this.error = error?.message || '검수 상세를 불러오지 못했습니다.';
        }

        this.detailLoading = false;
        if (render) await this.service.render();
    }

    private resetDecisionForm() {
        const review = this.detail?.review || {};
        this.decisionForm = {
            comment: review.comment || '',
            reason_code: review.reason_code || 'grounded_ok',
            change_summary: ''
        };
    }

    public async claimNext() {
        if (!this.isReviewerRole()) return;
        if (this.actionLoading) return;
        this.actionLoading = true;
        this.error = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call("claim_next");
            if (code === 200 && data?.claimed && data?.detail?.review?.id) {
                this.selectedReviewId = data.detail.review.id;
                this.detail = data.detail;
                this.resetDecisionForm();
                await this.load();
            } else if (code === 200) {
                this.availableCount = Number(data?.available_count || 0);
                this.error = data?.message === 'no_assigned_items'
                    ? '배정된 검수 항목이 없습니다.'
                    : '검수할 수 있는 후보가 없습니다.';
            } else {
                await this.service.modal.error(data?.message || '검수 항목을 가져오지 못했습니다.');
            }
        } catch (error: any) {
            await this.service.modal.error(error?.message || '검수 항목을 가져오지 못했습니다.');
        }

        this.actionLoading = false;
        await this.service.render();
    }

    public async decide(decision: string) {
        if (!this.selectedReviewId || !this.detail) return;
        if (!this.canDecide()) {
            await this.service.modal.error('배정된 검수 항목만 판정할 수 있습니다.');
            return;
        }
        if (decision !== 'approved' && !this.hasNonApprovalMemo()) {
            await this.service.modal.error('반려 또는 수정 요청 사유를 입력해주세요.');
            return;
        }

        const label = this.decisionLabel(decision);
        const confirmed = await this.service.modal.show({
            title: `검수 ${label}`,
            message: `선택한 항목을 ${label} 처리하시겠습니까?`,
            action: label,
            status: decision === 'approved' ? 'success' : 'warning'
        });
        if (!confirmed) return;

        this.actionLoading = true;
        await this.service.render();

        try {
            const { code, data } = await wiz.call("decide", {
                review_id: this.selectedReviewId,
                decision,
                score: this.defaultScore(decision),
                comment: this.decisionForm.comment,
                reason_code: this.decisionForm.reason_code || this.defaultReason(decision),
                change_summary: this.decisionForm.change_summary
            });
            if (code === 200) {
                this.selectedReviewId = '';
                await this.load();
            } else {
                await this.service.modal.error(data?.message || '검수 판정 저장에 실패했습니다.');
            }
        } catch (error: any) {
            await this.service.modal.error(error?.message || '검수 판정 저장에 실패했습니다.');
        }

        this.actionLoading = false;
        await this.service.render();
    }

    private hasNonApprovalMemo() {
        const comment = String(this.decisionForm.comment || '').trim();
        const change = String(this.decisionForm.change_summary || '').trim();
        return !!(comment || change);
    }

    private defaultScore(decision: string) {
        if (decision === 'approved') return 1;
        if (decision === 'change_requested') return 0.5;
        return 0;
    }

    private defaultReason(decision: string) {
        if (decision === 'approved') return 'grounded_ok';
        if (decision === 'change_requested') return 'needs_revision';
        return 'not_grounded';
    }

    public get selectedReview() {
        return this.detail?.review || this.queue.find((item: any) => item.id === this.selectedReviewId) || {};
    }

    public canDecide() {
        const status = this.detail?.review?.status || '';
        return this.isReviewerRole() && (status === 'assigned' || status === 'inspecting');
    }

    public number(value: any) {
        return Number(value || 0).toLocaleString();
    }

    public shortId(value: any) {
        value = String(value || '');
        if (!value) return '-';
        return value.length > 10 ? value.slice(0, 8) : value;
    }

    public pageLabel() {
        const pageNo = this.detail?.page?.page_no || this.detail?.chunk?.page_no || 0;
        if (!pageNo) return '-';
        return `${pageNo}쪽`;
    }

    public evidenceIds() {
        const raw = this.detail?.review?.evidence_ids || this.detail?.chunk?.evidence_id || '';
        if (Array.isArray(raw)) return raw.filter(Boolean);
        const value = String(raw || '').trim();
        if (!value) return [];
        try {
            const parsed = JSON.parse(value);
            if (Array.isArray(parsed)) return parsed.filter(Boolean);
            if (parsed) return [String(parsed)];
        } catch (error) {
            return value.split(',').map((item: string) => item.trim()).filter(Boolean);
        }
        return [];
    }

    public primaryEvidence() {
        return this.detail?.chunk?.evidence_id || this.evidenceIds()[0] || '';
    }

    public sourceTitle() {
        return this.detail?.document?.title || this.detail?.review?.source_document_id || '-';
    }

    public collectionScope() {
        return this.detail?.collection_scope || {};
    }

    public collectionTitle() {
        const scope = this.collectionScope();
        return scope?.collection_title
            || this.detail?.document?.collection_title
            || this.detail?.document?.collection_id
            || scope?.collection_id
            || '-';
    }

    public evidenceScopeLabel() {
        if (!this.detail) return '-';
        return this.detail?.scope_valid === false ? '범위 확인 필요' : '근거 연결됨';
    }

    public evidenceScopeClass() {
        return this.detail?.scope_valid === false
            ? 'border-amber-200 bg-amber-50 text-amber-700'
            : 'border-emerald-200 bg-emerald-50 text-emerald-700';
    }

    public pageText() {
        return this.detail?.page?.text || '-';
    }

    public chunkText() {
        return this.detail?.chunk?.text || this.detail?.review?.input_text || '-';
    }

    public gateResults() {
        return this.detail?.auto_gates || [];
    }

    public gateSummaryLabel() {
        const gates = this.gateResults();
        if (!gates.length) return '기록 없음';
        const failed = gates.filter((gate: any) => gate.status === 'failed' || gate.status === 'blocked').length;
        const pending = gates.filter((gate: any) => gate.status === 'pending').length;
        if (failed) return `확인 필요 ${failed}`;
        if (pending) return `대기 ${pending}`;
        return '통과';
    }

    public gateSummaryClass() {
        const label = this.gateSummaryLabel();
        if (label.indexOf('확인 필요') === 0) return 'border-rose-200 bg-rose-50 text-rose-700';
        if (label.indexOf('대기') === 0) return 'border-amber-200 bg-amber-50 text-amber-700';
        if (label === '통과') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        return 'border-gray-200 bg-gray-50 text-gray-600';
    }

    public gateLabel(gate: any) {
        const id = gate?.gate_id || '';
        const labels: any = {
            'review.qa.complete': '질문/답변 확인',
            'review.evidence.linked': '근거 연결 확인',
            'review.scope.match': '컬렉션 범위 확인',
            'dataset.source.traceable': '근거 출처 추적',
            'dataset.evidence.exists': '근거 존재',
            'candidate.schema.valid': 'QA 형식',
            'candidate.grounded': '답변 근거성',
            'citation.match': '인용 근거 일치',
            'dataset.duplicate.check': '중복 후보 확인',
            'dataset.g3.ready': '검수 준비 완료'
        };
        return gate?.label || labels[id] || id || '-';
    }

    public gateMessage(gate: any) {
        return gate?.local_message || gate?.message || '';
    }

    public gateStatusLabel(status: string) {
        switch (status) {
            case 'passed': return '통과';
            case 'failed': return '실패';
            case 'blocked': return '보류';
            case 'pending': return '대기';
            default: return status || '-';
        }
    }

    public gateStatusClass(status: string) {
        switch (status) {
            case 'passed': return 'border-emerald-200 bg-emerald-50 text-emerald-700';
            case 'failed': return 'border-rose-200 bg-rose-50 text-rose-700';
            case 'blocked':
            case 'pending': return 'border-amber-200 bg-amber-50 text-amber-700';
            default: return 'border-gray-200 bg-gray-50 text-gray-600';
        }
    }

    public statusLabel(status: string) {
        switch (status) {
            case 'pending': return '대기';
            case 'assigned': return '배정됨';
            case 'inspecting': return '검수 중';
            case 'completed': return '완료';
            case 'approved': return '승인';
            case 'rejected': return '반려';
            case 'change_requested': return '수정 요청';
            case 'review_requested': return '검수 요청';
            case 'in_review': return '검수 중';
            default: return status || '-';
        }
    }

    public decisionLabel(decision: string) {
        switch (decision) {
            case 'approved': return '승인';
            case 'rejected': return '반려';
            case 'change_requested': return '수정 요청';
            default: return decision || '-';
        }
    }

    public resultDecision() {
        return this.decisionLabel(this.detail?.review?.decision || '');
    }

    public resultReason() {
        switch (this.detail?.review?.reason_code || '') {
            case 'grounded_ok': return '근거에 맞음';
            case 'needs_revision': return '수정 필요';
            case 'not_grounded': return '근거 부족';
            case 'out_of_scope': return '범위 밖';
            case 'duplicate': return '중복';
            default: return this.detail?.review?.reason_code || '-';
        }
    }

    public resultScore() {
        const score = this.detail?.review?.score;
        if (score === undefined || score === null || score === '') return '-';
        return Number(score || 0).toFixed(2);
    }

    public resultComment() {
        return this.detail?.review?.comment || '-';
    }

    public statusClass(status: string) {
        switch (status) {
            case 'completed':
            case 'approved':
                return 'border-emerald-200 bg-emerald-50 text-emerald-700';
            case 'inspecting':
            case 'assigned':
            case 'in_review':
                return 'border-indigo-200 bg-indigo-50 text-indigo-700';
            case 'pending':
            case 'review_requested':
                return 'border-amber-200 bg-amber-50 text-amber-700';
            case 'rejected':
            case 'change_requested':
                return 'border-rose-200 bg-rose-50 text-rose-700';
            default:
                return 'border-gray-200 bg-gray-50 text-gray-600';
        }
    }

    public toneClass(tone: string) {
        switch (tone) {
            case 'green': return 'border-emerald-100 bg-emerald-50 text-emerald-700';
            case 'amber': return 'border-amber-100 bg-amber-50 text-amber-700';
            case 'indigo': return 'border-indigo-100 bg-indigo-50 text-indigo-700';
            case 'blue': return 'border-sky-100 bg-sky-50 text-sky-700';
            default: return 'border-gray-100 bg-gray-50 text-gray-600';
        }
    }

    public rowClass(id: string) {
        return this.selectedReviewId === id ? 'border-gray-950 bg-gray-950 text-white' : 'border-gray-200 bg-white text-gray-900 hover:border-gray-300 hover:bg-gray-50';
    }

    public rowMetaClass(id: string) {
        return this.selectedReviewId === id ? 'text-white/60' : 'text-gray-400';
    }
}

export default PageReviewComponent;